









































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { SystemApi, ValueListItem } from 'performo-api';
import { mapGetters } from 'vuex';

@Component({
  components: {},
  computed: mapGetters({
    sys: 'systemApi'
  })
})
export default class RequestTypePicker extends Vue {
  @Prop({ required: false, default: false })
  private required?: boolean;

  @Prop({ required: false, default: false })
  private hideAll?: boolean;

  @Prop({ required: true })
  private value!: string;

  @Prop({ required: true, type: String })
  private propertyId!: string;

  @Prop({ required: false, default: undefined })
  private jobTypeFilter!: string;

  @Prop({ required: false, default: 'Request Type' })
  private labelOverride?: string;

  get getValue() {
    return this.value;
  }

  private loadingRequestTypes = false;
  private sys!: SystemApi;

  RequestTypes: ValueListItem[] = [];

  get RequestTypesSorted() {
    if (!this.RequestTypes) {
      return null;
    }
    return this.RequestTypes.sort((a, b) => {
      if (a.valueListValue && b.valueListValue) {
        return a.valueListValue.localeCompare(b.valueListValue);
      }
      return 0;
    });
  }

  @Watch('propertyId', { immediate: true })
  @Watch('jobTypeFilter')
  private async loadRequestTypes() {
    this.loadingRequestTypes = true;
    this.RequestTypes = [];
    this.RequestTypes = await this.sys.getRequestTypes({
      propertyId: this.propertyId,
      jobTypeFilter: this.jobTypeFilter
    });
    this.loadingRequestTypes = false;
  }

  public RequestTypeListContains(RequestType: string) {
    let found = false;
    this.RequestTypes.forEach((element) => {
      if (element.valueListValue === RequestType) {
        found = true;
      }
    });
    return found;
  }
}
